import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const $container = $('.banner__container');
const $title = $('.banner__title');

if ($title.length > 0) {
    const words = $title.html().split(' ');
    const count = words.length;
    const treshold = Math.ceil(count / 2);

    let firstHalf = '<div>';
    for (let index = 0; index < treshold; index++) {
        firstHalf += words[index].replace(/\s/g, '');

        if (index < treshold - 1) {
            firstHalf += ' ';
        } else {
            firstHalf += '</div>';
        }
    }
    let secondHalf = '<div>';
    for (let index = treshold; index < count; index++) {
        secondHalf += words[index].replace(/\s/g, '');

        if (index < count - 1) {
            secondHalf += ' ';
        } else {
            secondHalf += '</div>';
        }
    }

    secondHalf === '<div>' ? $title.html(firstHalf) : $title.html(firstHalf + secondHalf);

    $(function () {
        scaleDownTitle().then(() => $title.addClass('banner__title--active'));
        $window.on(
            'resize:width',
            debounce(() => {
                const $titleChildren = $title.children('div');
                $titleChildren.css('font-size', '');
                scaleDownTitle();
            })
        );
    });
}

function scaleDownTitle() {
    return new Promise(function (resolve, reject) {
        if ($title.width() <= $container.width()) {
            resolve('done');
        } else {
            const $titleChildren = $title.children('div');
            let fontSize = parseInt($titleChildren.css('font-size'));
            fontSize -= 5;
            $titleChildren.css('font-size', fontSize + 'px');
            resolve(scaleDownTitle());
        }
    });
}
